import React, { useEffect, useState } from "react";
import AuthLayout from "../authLayout";
import { signIn } from "../../utils/router/constant";
import { useLocation, useNavigate } from "react-router-dom";
import Input from "../../components/common/FormFields/input";
import Button from "../../components/common/button";
import { useForm } from "react-hook-form";
import Success from "./component/success";
import api from "../../utils/interface";
import { toast } from "react-toastify";
import { clearExistingToken, getCodeFromUrl, getParamsFromURL, setParamsInURL } from "../../utils/helper";
import { CloseEyeIcon, OpenEyeIcon } from "../../assets/images/svg/svg";
import AgDetail from "../authLayout/agDetail";

const Password = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPasswrd, setShowPassword] = useState(false);
  const [showConfirmPasswrd, setShowConfirmPassword] = useState(false);
  const [success, setSuccess] = useState(false);
  const [fullName, setFullName] = useState(null);
  const [emailId, setEmailId] = useState(null);
  const [mobile, setMobile] = useState(null);

  const codeFromUrl = getCodeFromUrl();

  // const [firstName, lastName] = fullName ? fullName.split(" ") : ["", ""];
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    watch,
    setValue,
  } = useForm({
    mode: "onChange",
  });

  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setSuccess(params["success"]); 
          setFullName(params["name"]);       
          setEmailId(params["email"]); 
          setMobile(params["mobile"]); 
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);

  useEffect(() => {
    if (codeFromUrl) {
      setValue("entity", codeFromUrl);
    }
  }, [codeFromUrl, setValue]);

  const passwordSuffix = () => {
    return (
      <button
        className="send--otp"
        type="button"
        onClick={() => setShowPassword(!showPasswrd)}
      >
        {showPasswrd ? <CloseEyeIcon /> : <OpenEyeIcon/>}
      </button>
    )
  };

  const confirmPasswordSuffix = () => {
    return (
      <button
        className="send--otp"
        type="button"
        onClick={() => setShowConfirmPassword(!showConfirmPasswrd)}
      >
        {showConfirmPasswrd ? <CloseEyeIcon /> : <OpenEyeIcon/>}
      </button>
    )
  };

  const password = watch("password");

  const onSubmit = async (data) => {
    clearExistingToken();

    const completeData = {
      password: password,
      mobile: mobile,
      email_id: emailId,
      name: fullName,
      baseUrl: codeFromUrl,
    };

    try {
      await api.post(`/agsp/useraccount/createCustomerAccount`, completeData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const params = await setParamsInURL(location, {success: true});
      navigate(`${location.pathname}?${params}`);
    } catch (err) {
      toast.error(err.response?.data?.error_message || "An error occurred");
    }
  };

  return (
    <AuthLayout>
      {success ? (
        <Success />
      ) : (
        <div className="auth--form--wrapper">
          <AgDetail />
          <h1 className="auth--title">Welcome! Sign Up into your account</h1>
          <p className="auth--subtitle">
            Sign Up to manage your insurance policies with ease
          </p>
          <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <div className="auth--form">
              <Input
                type={showPasswrd ? "text" : "password"}
                placeholder="Password"
                name="password"
                rules={{
                  required: {
                    value: true,
                    message: "Required field",
                  },
                  pattern: {
                    value: /^(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/,
                    message:
                      "Password must be at least 8 characters long and include at least one special character",
                  },
                }}
                control={control}
                errors={errors}
                suffix={passwordSuffix}
              />
              <Input
                type={showConfirmPasswrd ? "text" : "password"}
                placeholder="Confirm Password"
                name="confirmPassword"
                rules={{
                  required: {
                    value: true,
                    message: "Required field",
                  },
                  validate: (value) =>
                    value === password ||
                    "Confirm password should match password entered",
                }}
                control={control}
                errors={errors}
                suffix={confirmPasswordSuffix}
              />
              <Button
                type="submit"
                variant="primary"
                label="Submit"
                disabled={!isValid}
              />
            </div>
          </form>
          <div className="or--wrapper">
            <div className="line"></div>
            <span className="or--wrapper--text">or</span>
            <div className="line"></div>
          </div>
          <Button
            onClick={() => navigate(signIn)}
            type="button"
            variant="outlined"
            label="Sign In"
          />
        </div>
      )}
    </AuthLayout>
  );
};

export default Password;
